import { render, staticRenderFns } from "./Anomalies.vue?vue&type=template&id=eab37a9a&"
import script from "./Anomalies.vue?vue&type=script&lang=js&"
export * from "./Anomalies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports